import React from "react"

const ExpandableIcon = ({ isExpanded, onClick, rotation }) => {
    let style

    if (rotation) {
        style = {
            transform: `rotate(${rotation}deg)`
        }
    }

    return (
        <span
            className={`fa fa-chevron-${isExpanded ? "up" : "down"}`}
            onClick={onClick}
            style={style}
        />
    )
}

export default ExpandableIcon
